







import { FitButton, FitIcon } from '@tencent/wphk-ui';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    FitButton,
    FitIcon,
  },
})
export default class ReviewIng extends Vue {
  @Prop({ default: 'waiting' }) public icon;
  @Prop() public title;
  @Prop() public desc;
}
